import PageHeader from './PageHeader';

export default {
  PageHeader,
};
